// This file was generated using `pay js:run gql-v1 --type=fragment --name=LegalEntityAddress --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment LegalEntityAddressFragment on OpenapiLegalEntityAddress {
    city
    country
    line1
    line2
    postal_code
    state
    town
  }
`;

export const legalEntityAddressFragment: LegalEntityAddressFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type LegalEntityAddressFragmentData = {
  readonly __typename: 'OpenapiLegalEntityAddress';
  readonly city: string | null;
  readonly country: string | null;
  readonly line1: string | null;
  readonly line2: string | null;
  readonly postal_code: string | null;
  readonly state: string | null;
  readonly town: string | null;
};

export type LegalEntityAddressFragmentVariables = Exact<{[key: string]: never}>;

const legalEntityAddressFragmentPermissions = {} as const;

doc.permissions = legalEntityAddressFragmentPermissions;

export type LegalEntityAddressFragmentPermissions = V1PermissionToken<
  typeof legalEntityAddressFragmentPermissions
>;

export type LegalEntityAddressFragmentDocument = GraphQlDocument<
  LegalEntityAddressFragmentData,
  LegalEntityAddressFragmentVariables,
  LegalEntityAddressFragmentPermissions
>;
